/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Keyword_EducationInputs */



/**
* | output |
* | --- |
* | "Education" |
*
* @param {Subtitle_Export_Keyword_EducationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_keyword_education = /** @type {((inputs?: Subtitle_Export_Keyword_EducationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Keyword_EducationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Éducation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausbildung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Istruzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Образование")
	if (locale === "es") return /** @type {LocalizedString} */ ("Educación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("教育")
	if (locale === "ja") return /** @type {LocalizedString} */ ("教育")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शिक्षा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Educação")
	return /** @type {LocalizedString} */ ("Education")
});